import * as api from '../Firebase/apiSetting'

import { SORT, VIEW } from '../config/tableLayout'

const PARCEL_LIST_VIEW_CHANGED = 'PARCEL_LIST_VIEW_CHANGED'
const PARCEL_LIST_SORT_CHANGED = 'PARCEL_LIST_SORT_CHANGED'
const USER_SETTINGS_INIT = 'USER_SETTINGS_INIT'
const USER_SETTINGS_CHANGED = 'USER_SETTINGS_CHANGED'
const CHECK_VIEW_UPDATE = 'CHECK_VIEW_UPDATE'
const RESET_VIEW_UPDATE = 'RESET_VIEW_UPDATE'
export const FILTER_SET = 'FILTER_SET'
export const FILTER_REMOVE = 'FILTER_REMOVE'

export const parcelListViewChanged = view => {
  return (dispatch, getState) => {
    if (getState().tableLayout.viewUpdate) {
      dispatch(onParcelListViewChanged(VIEW.NONE))
      dispatch(resetViewUpdate())
    }
    setTimeout(() => {
      dispatch(onParcelListViewChanged(view))
    }, 100)
  }
}

const onParcelListViewChanged = view => {
  return {
    type: PARCEL_LIST_VIEW_CHANGED,
    view: view
  }
}

export const checkViewUpdate = view => {
  return {
    type: CHECK_VIEW_UPDATE,
    view: view
  }
}

const resetViewUpdate = () => {
  return {
    type: RESET_VIEW_UPDATE
  }
}

export const parcelListSortChanged = sorted => {
  return {
    type: PARCEL_LIST_SORT_CHANGED,
    sorted: sorted
  }
}

export const settingsReceive = settings => {
  return {
    type: USER_SETTINGS_INIT,
    settings: settings
  }
}

export const userSettingsChanged = settings => {
  return dispatch => {
    dispatch(onUserSettingsChanged(settings))
    api.saveSettings(settings)
  }
}

export const onUserSettingsChanged = settings => {
  return {
    type: USER_SETTINGS_CHANGED,
    settings: settings
  }
}

export const setFilter = filter => {
  return {
    type: FILTER_SET,
    filter: filter
  }
}

export const removeFilter = () => {
  return {
    type: FILTER_REMOVE
  }
}

const initState = {
  view: VIEW.SUMMARY,
  viewUpdate: false,
  sorted: SORT.PARCEL,
  userSettings: {
    views: {},
    lastIndex: 0,
    order: []
  },
  filter: {
    0: [0, '', -1],
    count: 1
  },
  hasFilter: false
}

export default (state = initState, action) => {
  switch (action.type) {
    case PARCEL_LIST_VIEW_CHANGED:
      return Object.assign({}, state, {
        view: action.view
      })
    case PARCEL_LIST_SORT_CHANGED:
      return Object.assign({}, state, {
        sorted: action.sorted,
        filter: { ...initState.filter },
        hasFilter: false
      })
    case USER_SETTINGS_INIT:
    case USER_SETTINGS_CHANGED:
      return Object.assign({}, state, {
        userSettings: action.settings
      })
    case CHECK_VIEW_UPDATE:
      const u = action.view[0] === 'U' && action.view === state.view
      return Object.assign({}, state, {
        viewUpdate: u
      })
    case RESET_VIEW_UPDATE:
      return Object.assign({}, state, {
        viewUpdate: false
      })
    case FILTER_SET:
      return Object.assign({}, state, {
        filter: action.filter,
        hasFilter: true
      })
    case FILTER_REMOVE:
      return Object.assign({}, state, {
        filter: { ...initState.filter },
        hasFilter: false
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tableLayout.js